import ExcelBetUpload from '@/component/excel/ExcelBetUpload';
import { Box, Card, CardContent, Divider } from '@mui/material';
import Header from '@/component/Header';
export default function ExcelUploadBet() {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', sm: '0px' },
        }}
      >
        <Card>
          <Header title="사용자 베팅 포인트 지급" />
          <Divider />
          <CardContent>
            <ExcelBetUpload />
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
